// src/context/errors/errorCatalog.js

const errorCatalog = {
  /*	- это часть функционала, которая обрабатывается отдельно! 
  AUDIO_NOT_RECOGNIZED: {
    success: false,
    message: {
      ru: 'Аудиозапись не распознана, попробуйте ещё раз',
      en: 'Audio not recognized, please try again',
      de: 'Audio nicht erkannt, bitte versuche es erneut',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 200,
  },*/
  AUDIO_TIME_ENDED: {
    success: false,
    message: {
      ru: 'Время на аудиозапись закончилось, возобновите занятия позже',
      en: 'Audio recording time ended, resume later',
      de: 'Die Aufnahmezeit ist abgelaufen, bitte später fortfahren',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 200,
  },
  LANGUAGE_SETTINGS_NOT_FOUND: {
    success: false,
    message: {
      ru: 'Вы не выбрали основной и изучаемый языки. Пожалуйста, укажите их в настройках.',
      en: 'Main and target languages not selected. Please set them in settings.',
      de: 'Haupt- und Zielsprache nicht ausgewählt. Bitte in den Einstellungen festlegen.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 200,
  },
	INVALID_CREDENTIALS: {
	  success: false,
	  message: {
		ru: 'Неверный email или пароль. Попробуйте ещё раз.',
		en: 'Invalid email or password. Please try again.',
		de: 'Ungültige E-Mail oder Passwort. Bitte versuche es erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 401,
	},  
  SEND_DIALOG_DATA_ERROR: {
    success: false,
    message: {
      ru: 'Не удалось отправить данные диалога. Попробуйте снова.',
      en: 'Failed to send dialog data. Please try again.',
      de: 'Dialogdaten konnten nicht gesendet werden. Bitte versuche es erneut.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  BACKEND_RESPONSE_ERROR: {
    success: false,
    message: {
      ru: 'Ошибка сервера. Пожалуйста, попробуйте позже.',
      en: 'Server error. Please try again later.',
      de: 'Serverfehler. Bitte versuche es später erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  UNEXPECTED_STEP_ID: {
    success: false,
    message: {
      ru: 'Некорректный шаг диалога. Пожалуйста, начните заново.',
      en: 'Incorrect dialog step. Please start over.',
      de: 'Ungültiger Dialogschritt. Bitte von vorne beginnen.',
    },
    retry: false,
    severity: 'medium',
    httpStatus: 400,
  },
  DIALOG_FETCH_ERROR: {
    success: false,
    message: {
      ru: 'Не удалось загрузить диалог. Проверьте соединение.',
      en: 'Failed to load dialog. Check your connection.',
      de: 'Dialog konnte nicht geladen werden. Bitte Verbindung überprüfen.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  EXAM_DATA_FETCH_ERROR: {
    success: false,
    message: {
      ru: 'Не удалось загрузить данные экзамена.',
      en: 'Failed to load exam data.',
      de: 'Prüfungsdaten konnten nicht geladen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  GAME_DATA_FETCH_ERROR: {
    success: false,
    message: {
      ru: 'Не удалось загрузить данные игры.',
      en: 'Failed to load game data.',
      de: 'Spieldaten konnten nicht geladen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  FETCH_RESULT_FAILED: {
    success: false,
    message: {
      ru: 'Не удалось получить результаты.',
      en: 'Failed to fetch results.',
      de: 'Ergebnisse konnten nicht abgerufen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  LESSON_DATA_FETCH_ERROR: {
    success: false,
    message: {
      ru: 'Не удалось загрузить данные урока.',
      en: 'Failed to load lesson data.',
      de: 'Lektionsdaten konnten nicht geladen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  FETCH_LESSON_FAILED: {
    success: false,
    message: {
      ru: 'Не удалось загрузить урок. Проверьте соединение.',
      en: 'Failed to load lesson. Check your connection.',
      de: 'Lektion konnte nicht geladen werden. Bitte Verbindung überprüfen.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  FETCH_ACHIEVEMENTS_ERROR: {
    success: false,
    message: {
      ru: 'Не удалось загрузить достижения.',
      en: 'Failed to load achievements.',
      de: 'Erfolge konnten nicht geladen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR1_PROCESSING_AUDIO: {
    success: false,
    message: {
      ru: 'Ошибка обработки аудио (тип 1).',
      en: 'Audio processing error (type 1).',
      de: 'Fehler bei der Audioverarbeitung (Typ 1).',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_WHILE_RESAMPLING: {
    success: false,
    message: {
      ru: 'Ошибка при ресэмплировании аудио.',
      en: 'Error while resampling audio.',
      de: 'Fehler beim Resampling von Audio.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_PROCESSING_AUDIO: {
    success: false,
    message: {
      ru: 'Ошибка обработки аудио. Попробуйте снова.',
      en: 'Audio processing error. Please try again.',
      de: 'Fehler bei der Audioverarbeitung. Bitte versuche es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_SPEECH_RECOGNITION: {
    success: false,
    message: {
      ru: 'Ошибка распознавания речи.',
      en: 'Speech recognition error.',
      de: 'Fehler bei der Spracherkennung.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_SPEECH_RESTART: {
    success: false,
    message: {
      ru: 'Ошибка перезапуска распознавания речи.',
      en: 'Error restarting speech recognition.',
      de: 'Fehler beim Neustart der Spracherkennung.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_SPEECH_STOP_ON_UNMOUNT: {
    success: false,
    message: {
      ru: 'Ошибка остановки распознавания при размонтировании.',
      en: 'Error stopping speech recognition on unmount.',
      de: 'Fehler beim Stoppen der Spracherkennung beim Entladen.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_SPEECH_START: {
    success: false,
    message: {
      ru: 'Ошибка запуска распознавания речи.',
      en: 'Error starting speech recognition.',
      de: 'Fehler beim Starten der Spracherkennung.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  SPEECH_RECOGNITION_UNAVAILABLE: {
    success: false,
    message: {
      ru: 'Распознавание речи недоступно или не инициализировано.',
      en: 'Speech recognition unavailable or not initialized.',
      de: 'Spracherkennung nicht verfügbar oder nicht initialisiert.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_SPEECH_STOP: {
    success: false,
    message: {
      ru: 'Ошибка остановки распознавания речи.',
      en: 'Error stopping speech recognition.',
      de: 'Fehler beim Stoppen der Spracherkennung.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_FETCH_MESSAGES: {
    success: false,
    message: {
      ru: 'Не удалось получить сообщения.',
      en: 'Failed to fetch messages.',
      de: 'Nachrichten konnten nicht abgerufen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_MARK_MESSAGE_READ: {
    success: false,
    message: {
      ru: 'Не удалось пометить сообщение как прочитанное.',
      en: 'Failed to mark message as read.',
      de: 'Nachricht konnte nicht als gelesen markiert werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_TON_CONNECT_INIT: {
    success: false,
    message: {
      ru: 'Ошибка инициализации TON Connect. Попробуйте снова.',
      en: 'TON Connect initialization error. Please try again.',
      de: 'Fehler bei der Initialisierung von TON Connect. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_FETCH_TON_RATE: {
    success: false,
    message: {
      ru: 'Не удалось загрузить курс TON.',
      en: 'Failed to fetch TON rate.',
      de: 'TON-Kurs konnte nicht geladen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_TRANSACTION_CHECK: {
    success: false,
    message: {
      ru: 'Ошибка проверки транзакции.',
      en: 'Transaction check error.',
      de: 'Fehler bei der Transaktionsprüfung.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_PAYMENT_CONFIRMATION: {
    success: false,
    message: {
      ru: 'Ошибка отправки подтверждения платежа.',
      en: 'Payment confirmation error.',
      de: 'Fehler bei der Zahlungsbestätigung.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_PARSE_TRANSACTION: {
    success: false,
    message: {
      ru: 'Ошибка обработки транзакции. Попробуйте снова.',
      en: 'Transaction parsing error. Please try again.',
      de: 'Fehler beim Verarbeiten der Transaktion. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_TON_PAYMENT: {
    success: false,
    message: {
      ru: 'Ошибка при отправке TON транзакции. Попробуйте снова.',
      en: 'TON payment error. Please try again.',
      de: 'Fehler bei der TON-Zahlung. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_STARS_POPUP: {
    success: false,
    message: {
      ru: 'Ошибка открытия окна оплаты звездами. Попробуйте снова.',
      en: 'Stars payment popup error. Please try again.',
      de: 'Fehler beim Öffnen des Sternzahlungsfensters. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_STARS_PAYMENT: {
    success: false,
    message: {
      ru: 'Ошибка создания платежа звездами. Попробуйте снова.',
      en: 'Stars payment invoice error. Please try again.',
      de: 'Fehler beim Erstellen der Sternzahlung. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_FETCHING_STATISTICS: {
    success: false,
    message: {
      ru: 'Не удалось загрузить статистику.',
      en: 'Failed to fetch statistics.',
      de: 'Statistiken konnten nicht geladen werden.',
    },
    retry: true,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_STOP_RECORDING_INVALID_STATE: {
    success: false,
    message: {
      ru: 'Ошибка остановки записи: неверное состояние.',
      en: 'Stop recording error: invalid state.',
      de: 'Fehler beim Stoppen der Aufnahme: ungültiger Zustand.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_EMPTY_BLOB: {
    success: false,
    message: {
      ru: 'Пустой аудиофайл при остановке записи.',
      en: 'Empty audio blob on stop recording.',
      de: 'Leere Audiodatei beim Stoppen der Aufnahme.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_GETTING_STREAM: {
    success: false,
    message: {
      ru: 'Ошибка получения аудиопотока.',
      en: 'Error getting audio stream.',
      de: 'Fehler beim Abrufen des Audiostreams.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_START_RECORDING: {
    success: false,
    message: {
      ru: 'Не удалось начать запись. Проверьте разрешения.',
      en: 'Failed to start recording. Check permissions.',
      de: 'Aufnahme konnte nicht gestartet werden. Überprüfen Sie die Berechtigungen.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_MIC_PERMISSION: {
    success: false,
    message: {
      ru: 'Нет доступа к микрофону. Проверьте разрешения.',
      en: 'Microphone access denied. Check permissions.',
      de: 'Kein Mikrofonzugriff. Überprüfen Sie die Berechtigungen.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_MICROPHONE_ACCESS: {
    success: false,
    message: {
      ru: 'Ошибка доступа к микрофону. Проверьте разрешения.',
      en: 'Microphone access error. Check permissions.',
      de: 'Fehler beim Zugriff auf das Mikrofon. Überprüfen Sie die Berechtigungen.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_MEDIA_RECORDER: {
    success: false,
    message: {
      ru: 'Ошибка MediaRecorder.',
      en: 'MediaRecorder error.',
      de: 'MediaRecorder-Fehler.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  ERROR_STOP_RECORDING: {
    success: false,
    message: {
      ru: 'Ошибка остановки записи.',
      en: 'Stop recording error.',
      de: 'Fehler beim Stoppen der Aufnahme.',
    },
    retry: false,
    severity: 'low',
    httpStatus: 500,
  },
  TELEGRAM_INIT_ERROR: {
    success: false,
    message: {
      ru: 'Ошибка инициализации Telegram. Попробуйте снова.',
      en: 'Telegram initialization error. Please try again.',
      de: 'Fehler bei der Telegram-Initialisierung. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'high',
    httpStatus: 500,
  },
  TEMP_REG_FAILED: {
    success: false,
    message: {
      ru: 'Временная регистрация не удалась. Попробуйте снова.',
      en: 'Temporary registration failed. Please try again.',
      de: 'Temporäre Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'high',
    httpStatus: 500,
  },
	REGISTRATION_FAILED: {
	  success: false,
	  message: {
		ru: 'Регистрация не удалась. Попробуйте снова.',
		en: 'Registration failed. Please try again.',
		de: 'Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'high',
	  httpStatus: 500,
	},
	AUTH_INIT_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка авторизации. Попробуйте снова.',
		en: 'Authorization error. Please try again.',
		de: 'Autorisierungsfehler. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'high',
	  httpStatus: 500,
	},
	TIMEOUT_ERROR: {
	  success: false,
	  message: {
		ru: 'Превышено время ожидания. Попробуйте снова.',
		en: 'Request timed out. Please try again.',
		de: 'Zeitüberschreitung bei der Anfrage. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'low',
	  httpStatus: 504,
	},
	MISSING_REQUIRED_DATA: {
	  success: false,
	  message: {
		ru: 'Недостаточно данных для обработки.',
		en: 'Missing required data for processing.',
		de: 'Erforderliche Daten für die Verarbeitung fehlen.',
	  },
	  retry: false,
	  severity: 'low',
	  httpStatus: 400,
	},
	RECOGNITION_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка распознавания.',
		en: 'Recognition error.',
		de: 'Erkennungsfehler.',
	  },
	  retry: false,
	  severity: 'low',
	  httpStatus: 500,
	},
	NO_OPTIONS: {
	  success: false,
	  message: {
		ru: 'Варианты ответа отсутствуют.',
		en: 'No response options available.',
		de: 'Keine Antwortmöglichkeiten verfügbar.',
	  },
	  retry: false,
	  severity: 'low',
	  httpStatus: 400,
	},
	INVALID_INDEX: {
	  success: false,
	  message: {
		ru: 'Неверный индекс варианта ответа.',
		en: 'Invalid response index.',
		de: 'Ungültiger Antwortindex.',
	  },
	  retry: false,
	  severity: 'low',
	  httpStatus: 400,
	},
	SEND_DATA_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка отправки данных. Попробуйте снова.',
		en: 'Data sending error. Please try again.',
		de: 'Fehler beim Senden der Daten. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	AUDIO_BLOB_MISSING: {
	  success: false,
	  message: {
		ru: 'Аудиозапись отсутствует. Попробуйте записать снова.',
		en: 'Audio recording missing. Please record again.',
		de: 'Audioaufnahme fehlt. Bitte erneut aufnehmen.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 400,
	},
	AUDIO_PROCESSING_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка обработки аудиозаписи. Попробуйте снова.',
		en: 'Audio processing error. Please try again.',
		de: 'Fehler bei der Audioverarbeitung. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	UNEXPECTED_STOP_RECORDING_ERROR: {
	  success: false,
	  message: {
		ru: 'Неожиданная ошибка при остановке записи.',
		en: 'Unexpected stop recording error.',
		de: 'Unerwarteter Fehler beim Beenden der Aufnahme.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	MAX_ATTEMPTS_REACHED: {
	  success: false,
	  message: {
		ru: 'Достигнуто максимальное количество попыток.',
		en: 'Maximum attempts reached.',
		de: 'Maximale Anzahl an Versuchen erreicht.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	UNKNOWN_BACKEND_ERROR: {
	  success: false,
	  message: {
		ru: 'Неизвестная ошибка сервера. Попробуйте позже.',
		en: 'Unknown server error. Please try later.',
		de: 'Unbekannter Serverfehler. Bitte versuchen Sie es später erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	STEP_ID_MISMATCH: {
	  success: false,
	  message: {
		ru: 'Несоответствие шага диалога. Попробуйте начать заново.',
		en: 'Dialog step mismatch. Please start over.',
		de: 'Dialogschritt stimmt nicht überein. Bitte von vorne beginnen.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	START_RECORD_BLOCKED: {
	  success: false,
	  message: {
		ru: 'Начало записи заблокировано.',
		en: 'Start recording blocked.',
		de: 'Aufnahmebeginn blockiert.',
	  },
	  retry: false,
	  severity: 'low',
	  httpStatus: 400,
	},
	START_RECORD_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка начала записи. Проверьте разрешения.',
		en: 'Start recording error. Check permissions.',
		de: 'Fehler beim Starten der Aufnahme. Berechtigungen überprüfen.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	STOP_RECORD_INCOMPLETE_DEPENDENCIES: {
	  success: false,
	  message: {
		ru: 'Ошибка остановки записи: отсутствуют зависимости.',
		en: 'Stop recording error: missing dependencies.',
		de: 'Fehler beim Beenden der Aufnahme: Abhängigkeiten fehlen.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	STOP_RECORD_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка остановки записи. Попробуйте снова.',
		en: 'Stop recording error. Please try again.',
		de: 'Fehler beim Beenden der Aufnahme. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	MISSING_GAME_ID: {
	  success: false,
	  message: {
		ru: 'Идентификатор игры отсутствует.',
		en: 'Game ID missing.',
		de: 'Spiel-ID fehlt.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	SENTENCE_NOT_FOUND_FOR_INDEX: {
	  success: false,
	  message: {
		ru: 'Предложение не найдено. Попробуйте снова.',
		en: 'Sentence not found. Please try again.',
		de: 'Satz nicht gefunden. Bitte versuchen Sie es erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 400,
	},
	SLOTS_NOT_INITIALIZED_FOR_SENTENCEINDEX: {
	  success: false,
	  message: {
		ru: 'Слоты не инициализированы для предложения.',
		en: 'Slots not initialized for sentence.',
		de: 'Slots für den Satz nicht initialisiert.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	CORRECT_WORD_NOT_FOUND_IN_AVAILABLEWORDS: {
	  success: false,
	  message: {
		ru: 'Правильное слово не найдено в доступных словах.',
		en: 'Correct word not found in available words.',
		de: 'Das richtige Wort wurde in den verfügbaren Wörtern nicht gefunden.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	SENTENCE_NOT_FOUND_FOR_CHECKANSWER: {
	  success: false,
	  message: {
		ru: 'Предложение для проверки ответа не найдено.',
		en: 'Sentence for answer check not found.',
		de: 'Satz zur Antwortprüfung nicht gefunden.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	SLOTS_NOT_FOUND_FOR_SENTENCEINDEX: {
	  success: false,
	  message: {
		ru: 'Слоты для предложения не найдены.',
		en: 'Slots for sentence not found.',
		de: 'Slots für den Satz nicht gefunden.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	INVALID_SENTENCE_STRUCTURE_FOR_SENTENCE: {
	  success: false,
	  message: {
		ru: 'Неверная структура предложения.',
		en: 'Invalid sentence structure.',
		de: 'Ungültige Satzstruktur.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	MISSING_IDS: {
	  success: false,
	  message: {
		ru: 'Отсутствуют необходимые идентификаторы.',
		en: 'Missing required IDs.',
		de: 'Erforderliche IDs fehlen.',
	  },
	  retry: false,
	  severity: 'medium',
	  httpStatus: 400,
	},
	AUDIO_PLAY_FAILED: {
	  success: false,
	  message: {
		ru: 'Не удалось воспроизвести аудио.',
		en: 'Audio playback failed.',
		de: 'Audiowiedergabe fehlgeschlagen.',
	  },
	  retry: true,
	  severity: 'low',
	  httpStatus: 500,
	},
	AUDIO_PLAYBACK_ERROR: {
	  success: false,
	  message: {
		ru: 'Ошибка воспроизведения аудио.',
		en: 'Audio playback error.',
		de: 'Fehler bei der Audiowiedergabe.',
	  },
	  retry: true,
	  severity: 'low',
	  httpStatus: 500,
	},
	TEST_ERROR: {
	  success: false,  
	  message: {
		ru: 'Тестовая ошибка',
		en: 'Test Error',
		de: 'Test Fehrler',
	  },
	  httpStatus: 500,
	},	
	UNKNOWN_ERROR: {
	  success: false,
	  message: {
		ru: 'Неизвестная ошибка. Попробуйте позже.',
		en: 'Unknown error. Please try later.',
		de: 'Unbekannter Fehler. Bitte versuchen Sie es später erneut.',
	  },
	  retry: true,
	  severity: 'medium',
	  httpStatus: 500,
	},
	
	
	
  // новые добавления ошибок при попытке починить не работающий микрофон в IOS
  ERROR_INSECURE_CONTEXT: {
    success: false,
    message: {
      ru: 'Микрофон доступен только через защищенное соединение (HTTPS).',
      en: 'Microphone is only available over secure connection (HTTPS).',
      de: 'Mikrofon ist nur über eine sichere Verbindung (HTTPS) verfügbar.',
    },
    retry: false,
    severity: 'high',
    httpStatus: 403,
  },
  ERROR_MIC_PERMISSION_DENIED: {
    success: false,
    message: {
      ru: 'Доступ к микрофону запрещен. Разрешите доступ в настройках браузера.',
      en: 'Microphone access denied. Please allow access in browser settings.',
      de: 'Mikrofonzugriff verweigert. Bitte erlauben Sie den Zugriff in den Browser-Einstellungen.',
    },
    retry: true,
    severity: 'high',
    httpStatus: 403,
  },
  ERROR_MIC_NOT_FOUND: {
    success: false,
    message: {
      ru: 'Микрофон не найден. Проверьте подключение устройства.',
      en: 'Microphone not found. Check device connection.',
      de: 'Mikrofon nicht gefunden. Überprüfen Sie die Geräteverbindung.',
    },
    retry: true,
    severity: 'high',
    httpStatus: 404,
  },
  ERROR_MIC_IN_USE: {
    success: false,
    message: {
      ru: 'Микрофон уже используется другим приложением. Закройте другие приложения и попробуйте снова.',
      en: 'Microphone is already in use by another application. Close other apps and try again.',
      de: 'Mikrofon wird bereits von einer anderen Anwendung verwendet. Schließen Sie andere Apps und versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 409,
  },
  ERROR_MIC_CONSTRAINTS: {
    success: false,
    message: {
      ru: 'Не удалось применить настройки микрофона. Устройство может не поддерживать требуемые параметры.',
      en: 'Failed to apply microphone settings. Device may not support required parameters.',
      de: 'Mikrofoneinstellungen konnten nicht angewendet werden. Das Gerät unterstützt möglicherweise die erforderlichen Parameter nicht.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 400,
  },
  ERROR_MIC_SECURITY: {
    success: false,
    message: {
      ru: 'Доступ к микрофону запрещен по соображениям безопасности. Используйте HTTPS.',
      en: 'Microphone access blocked for security reasons. Use HTTPS.',
      de: 'Mikrofonzugriff aus Sicherheitsgründen blockiert. Verwenden Sie HTTPS.',
    },
    retry: false,
    severity: 'high',
    httpStatus: 403,
  },
  ERROR_GETTING_STREAM: {
    success: false,
    message: {
      ru: 'Не удалось получить аудиопоток. Проверьте микрофон.',
      en: 'Failed to get audio stream. Check microphone.',
      de: 'Audio-Stream konnte nicht abgerufen werden. Überprüfen Sie das Mikrofon.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_MEDIARECORDER: {
    success: false,
    message: {
      ru: 'Ошибка записи аудио. Попробуйте еще раз.',
      en: 'Audio recording error. Try again.',
      de: 'Audioaufnahmefehler. Versuchen Sie es erneut.',
    },
    retry: true,
    severity: 'medium',
    httpStatus: 500,
  },
  ERROR_MEDIARECORDER_INIT: {
    success: false,
    message: {
      ru: 'Не удалось инициализировать запись. Устройство может не поддерживать аудиозапись.',
      en: 'Failed to initialize recording. Device may not support audio recording.',
      de: 'Aufnahme konnte nicht initialisiert werden. Das Gerät unterstützt möglicherweise keine Audioaufnahme.',
    },
    retry: true,
    severity: 'high',
    httpStatus: 500,
  },	
	
};

export default errorCatalog;
